import React from 'react';
import PropTypes from 'prop-types';
import StringHelper from '../../../Helpers/String';

function TarjetaInfo(props) {
    let suscripcion = props.tarjeta.split('-');
    if (suscripcion.length >= 5) {
        let banco = '';
        let tarjeta = suscripcion[0].trim();
        let ultimos4 = suscripcion[4].trim();
        let tarjetaClass = '';

        if (tarjeta.indexOf('VISA') > -1) {
            tarjetaClass = 'tarjeta-visa';
        }

        if (tarjeta.indexOf('MASTERCARD') > -1) {
            tarjetaClass = 'tarjeta-mastercard';
        }

        if (tarjeta.indexOf('AMERICAN EXPRESS') > -1) {
            tarjetaClass = 'tarjeta-amex';
        }

        if (!tarjetaClass) {
            tarjetaClass = 'tarjeta-otra';
        }

        if (suscripcion.length == 6) {
            banco = StringHelper.Capitalize(suscripcion[5].trim());
        }

        return (
            <div className="pasos-tarjeta">
                <p className="planes-titulo">El pago se debitar&aacute; de</p>
                <div className="tarjeta-banco">
                    <div className="tarjeta-izquierda">
                        <div className={`tarjeta ${tarjetaClass}`}> </div>
                    </div>
                    <div className="tarjeta-centro">
                        <p>
                            <b>**** {ultimos4}</b>
                        </p>
                        <p>{banco}</p>
                    </div>
                </div>
            </div>
        );
    }
    return null;
}

TarjetaInfo.propTypes = {
    tarjeta: PropTypes.string.isRequired,
};

export default TarjetaInfo;
